function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
            const video = entry.target
            video.src = video.dataset.src
            video.load()
            observer.unobserve(video);
        }
      });
    }, { threshold:0,rootMargin: '500px', });
  
    elements.forEach(el => observer.observe(el));
}
onViewLoad('.box5_video')
onViewLoad('.box6_video')
onViewLoad('.box7_video')
onViewLoad('.box13_item video')
  

var wFlag=window.innerWidth>750

// const lenis = new Lenis();
// lenis.on("scroll", ScrollTrigger.update);
// gsap.ticker.add((time) => {
//     lenis.raf(time * 1000);
// });
// gsap.ticker.lagSmoothing(0);

$(()=>{
    setTimeout(() => {
        $('.box1_title').css({transform:'translateY(0)',opacity:1})
    }, 200);

    

    ScrollTrigger.create({
        trigger:'.box1_1',
        start:'top top+=4%',
        end:'+=80%',
        pin:true,
        onUpdate: function (self) {
            let index = Math.floor(self.progress * 100);
            for(let i=0;i<4;i++){
                if(index>i*25){
                    $('.box1_1 div').eq(i).addClass('box1_active').siblings().removeClass('box1_active')
                }
            }
        }
    })

    //box2
    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })

    //box3
    showUp('.box3_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=4%',
            end:'+=40%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box3_content').toggleClass('box3Active',index>5)
            }
        })
    }
    var box3Swiper = new Swiper('.box3Swiper', {
        autoplay: true,
        effect: 'fade',
        loop:true,
        on:{
            slideChange: function(){
                var index = this.realIndex
                $('.box3_icon div:first-child p span').removeClass('opacity1')
                $(`.box3_icon div:first-child p:nth-child(${index+1}) span`).addClass('opacity1')
                $(`.box3_icon div:last-child p:nth-child(${index+1})`).addClass('opacity1').siblings().removeClass('opacity1')
            },
        },
    })
    $('.box3_icon div p').click(function(){
        var index = $(this).index()
        box3Swiper.slideTo(index+1,300,false)
        $('.box3_icon div:first-child p span').removeClass('opacity1')
        $(this).find('span').addClass('opacity1')
        $(`.box3_icon div:last-child p:nth-child(${index+1})`).addClass('opacity1').siblings().removeClass('opacity1')
    })

    //box4
    showUp('.box4_title')
     
    //box5
    var $video2 = $('.box5_video');
    if(wFlag){ 
        ScrollTrigger.create({
            trigger:'.box5_scrub',
            start:'top top+=4%',
            end:'+=200%',
            scrub:true,
            pin:true,
            // markers:true,
            onUpdate: function (self) {
                //console.log($video2[0].duration)
                $video2[0].currentTime = self.progress * 1.36
                $('.box5_title2').toggleClass('opacity1',self.progress>0.95)
            }
        })
    }else{
        $video2.attr('autoplay','true')
        $video2.on("ended", function () {
            $('.box5_title2').addClass('opacity1')
        });

    }

    //box6
    showUp('.box6_title')
    var $video1 = $('.box6_video');
    if(wFlag){ 
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top top+=30%',
            end:'+=80%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                //console.log($video1[0].duration)
                $video1[0].currentTime = self.progress * 2;
            }
        })
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top top+=4%',
            end:'+=80%',
            pin:true,
        })
    }else{
        $video1.attr('autoplay','true')
        //$video1.attr('loop','true')
    }

    //box7
    showUp('.box7_title')
    var $video = $('.box7_video');
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box7', 
            start:'top top+=20%',
            end:'+=60%',
            scrub:true,
            // markers:true,
            onUpdate: function (self) {
                //console.log($video[0].duration)
                $video[0].currentTime = self.progress * 4.04;
            }
        })
    }else{
        $video.attr('autoplay','true')
        //$video.attr('loop','true')
    }

    //box8
    ScrollTrigger.create({
        trigger:'.box8', 
        start:'top top+=20%',
        end:'+=10%',
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            if(index>2){
                $('.box8_light').addClass('box8_active')
            }
        },
    })

    //box9
    showUp('.box9_title1')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box9', 
            start:'top top+=4%',
            end:'+=30%',
            pin:true,
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box9_img').toggleClass('box9_active', index>4)
                $('.box9_title').toggleClass('opacity1', index>4)
                $('.box9_flag').toggleClass('opacity0', index>4)
            }
        })
    }

    //box10
    showUp('.box10_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box10', 
            start:'top+=10% top+=4%',
            end:'+=40%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to('.box10_items .box10_item:nth-child(1)',{opacity:0,x:'-50%'})
                .to('.box10_items .box10_item:nth-child(2)',{opacity:0,x:'50%'},'<')
                .to('.box10_info',{opacity:1})
                .to('.box10_num div',{y:'-34%',ease:'none',duration:0.5},'-=80%')
        })

        ScrollTrigger.create({
            trigger:'.box10', 
            start:'top top+=4%',
            end:'+=50%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box10_info', 
            start:'top+ bottom-=20%',
            end:'+=10%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .to('.box10_num div',{y:'-34%',ease:'none',duration:0.5})
        })
    }

    //box13
    showUp('.box13_title')
    if(wFlag){
        $('.box13_item').hover(function(){
            $('.box13_item video').each(function() {
                this.pause();
            });
            $(this).find('video')[0].play();
        })
    }else{
        new Swiper('.box13Swiper', {
            slidesPerView: 1.5,
            centeredSlides: true,
            autoplay:true,
        })
        $('.box13_item video').attr('autoplay','true')
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    
    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/oxva-slimstick-x'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
})